import { render, staticRenderFns } from "./MetricAlertCreateView.vue?vue&type=template&id=4443a35c&"
import script from "./MetricAlertCreateView.vue?vue&type=script&lang=js&"
export * from "./MetricAlertCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports